import { Box, IconButton } from "@mui/material";
import { CurrentUserSelector } from "@nerdjs/account-kit";
import { KronosTimer } from "../../kronos-kit";
import { useDispatch } from "react-redux";
import { useTalents } from "../../redux/talent/talentHooks";
import { setDrawerOpen } from "../../redux/appStatus/appStatusActions";
import { drawerOpenSelector } from "../../redux/appStatus/appStatusSelector";
import { FineLineLogo } from "../fineLineLogo/fineLineLogo";
import { useAppSelector } from "../hooks";
import { NerdAppBarProps } from "../nerdAppBar/nerdAppBar";
import { NerdAppBarDarkModeButton } from "../nerdAppBarDarkModeButton/nerdAppBarDarkModeButton";
import { NerdAppBarStopImpersonate } from "../nerdAppBarStopImpersonate/nerdAppBarStopImpesonate";
import NerdAppsMenuWrapper from "../nerdAppsMenuWrapper/nerdAppsMenuWrapper";
import { NerdUserMenu } from "../nerdUserMenu/nerdUserMenu";
import { CreateCenter } from "../createCenter/createCenter";

export const appBarConfig: NerdAppBarProps = {
  variant: "dense",
  content: [
    <Box sx={{ display: { xs: "none", sm: "block" } }} key="logo">
      <FineLineLogo />
    </Box>,
    <Box sx={{ display: { xs: "block", sm: "none" } }} key="Menu">
      <MenuOpenner />
    </Box>,
    <div style={{ flexGrow: 1 }} key={"divider1"} />,
    <KronosTimerVisibilityGate key="kronos" />,
    <div style={{ flexGrow: 1 }} key={"nerdAppMenustylingDiv"} />,
    // <Hidden smDown key="crisp">
    //   <JoyButton
    //     onClick={() => {
    //       window.open(
    //         "https://go.crisp.chat/chat/embed/?website_id=53d14c32-6127-4d29-9c22-48a3df45523c",
    //         "Support",
    //         "width=400,height=650,left=150,top=200,toolbar=0,status=0"
    //       );
    //     }}
    //     variant="soft"
    //     size="sm"
    //   >
    //     <i className="fa-solid fa-comment pright"></i>
    //     Support
    //   </JoyButton>
    // </Hidden>,
    <Box
      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
      key="appBarButtons"
    >
      <CreateCenter key="CreateCenter" />
      <NerdAppsMenuWrapper key={"NerdAppsMenuWrapper"} />
      <NerdAppBarDarkModeButton key={"nerdAppBarDarkModeButton"} />
      <NerdAppBarStopImpersonate key={"nerdAppBarStopImpesonate"} />
      <NerdUserMenu key={"myAccountButton"} />
    </Box>,
  ],
};

export {};

declare global {
  interface Window {
    $crisp: {
      push: (a: any) => void;
    };
  }
}

function MenuOpenner() {
  const dispatch = useDispatch();
  const drawerOpen = useAppSelector(drawerOpenSelector);

  return (
    <IconButton
      size="small"
      color="primary"
      onClick={() => dispatch(setDrawerOpen(!drawerOpen))}
    >
      <i style={{ fontSize: "inherit" }} className="fa-solid fa-bars"></i>
    </IconButton>
  );
}

function KronosTimerVisibilityGate() {
  const currentUser = useAppSelector(CurrentUserSelector);
  const { talents } = useTalents();

  const normalize = (value?: string) => (value ?? "").trim().toLowerCase();
  const currentFirstName = normalize(currentUser?.firstName);
  const currentLastName = normalize(currentUser?.lastName);

  if (!currentFirstName || !currentLastName) return null;

  const matchingTalent = talents?.find(
    (talent) =>
      normalize(talent.firstName) === currentFirstName &&
      normalize(talent.lastName) === currentLastName
  );

  if (!matchingTalent?.userUUID?.trim()) return null;

  return <KronosTimer />;
}
